import { Arrow } from './ui'

const community = ['ผู้เชี่ยวชาญ Wellness', 'ทีมแพทย์และบุคลากรสุขภาพ', 'เจ้าของธุรกิจ', 'ผู้บริหาร', 'Influencers', 'Media', 'Wellness Community']

export default function SpecialGuest() {
  return <section className="special-guest-feature" id="special-guest" aria-labelledby="special-guest-title">
    <div className="special-guest-heading">
      <p className="eyebrow">A SPECIAL CONNECTION</p>
      <h2 id="special-guest-title">Special <em>Guest.</em></h2>
      <p>ร่วมกับผู้คนที่เชื่อในพลังของ Wellness</p>
    </div>
    <div className="special-guest-layout">
      <div className="special-guest-copy">
        <span className="special-guest-label">SPECIAL GUEST</span>
        <h3>คุณเอ๋<br /><span>พรทิพย์</span></h3>
        <div className="special-guest-rule" aria-hidden="true" />
        <p>รายละเอียดการเข้าร่วมและรายชื่อแขกรับเชิญฉบับสมบูรณ์จะประกาศเพิ่มเติม</p>
        <a className="special-guest-link" href="#timeline">ดูกำหนดการงาน <Arrow /></a>
      </div>
    </div>
    <div className="special-guest-community"><p>GUESTS & COMMUNITY</p><ul>{community.map(item => <li key={item}>{item}</li>)}</ul></div>
  </section>
}
